import { omitBy, isNil, find, map } from "lodash";

const response = (orders: any[]) => {
  // For 'Split Shipment' :
  // we receive the child and parent in one whole response list
  // the parent will have an array of childIDs which is used to map to the parent
  // do not display the child in the main listing, so we filter it out
  const groupAllOrders = () => {
    const childIDs = new Set();

    orders.forEach((order) => {
      if (order.childrenOrderIDs) {
        order.childrenOrderIDs.forEach((childID: string) =>
          childIDs.add(childID),
        );
      }
    });

    const result = orders
      .map((order) => {
        if (order.childrenOrderIDs) {
          const childOrderList = order.childrenOrderIDs.map((childID: string) => {
            const childOrder = orders.find(
              (childOrder) => childOrder._id === childID,
            );
            if (childOrder) {
              childOrder.trackingNumber = `${childOrder.trackingNumber}/${childOrder.runningNumber}`;
              return childOrder;
            }
          });

          return { ...order, childOrders: childOrderList };
        }

        return order;
      })
      .filter((order) => !childIDs.has(order._id));

    return result;
  };

  return map(groupAllOrders(), (data: any) => {
    const getTypeName = (inputType: string) => {
      let typeObj = find(data.additionalCharges, (typeObj) => {
        return typeObj.type == inputType;
      });

      return typeObj?.name || "";
    };
    
    return omitBy(
      {
        ...data,
        isEdit: true,
        deliveryTypeName: getTypeName("DELIVERY_TYPE"),
        serviceTypeName: getTypeName("SERVICE_TYPE"),
        customer: data.senderID,
        customerLocation: data.senderLocationID,
        individualName: data.senderInfo?.fullName,
        emailAddress: data.senderInfo?.contactEmail,
        senderContact: {
          number: data.senderInfo?.contactNumber?.number,
          dialCode: data.senderInfo?.contactNumber?.countryCode,
        },
        senderAddress: {
          street1: data.senderInfo?.address?.street1,
          postcode: data.senderInfo?.address?.postcode,
          city: data.senderInfo?.address?.city,
          state: data.senderInfo?.address?.state,
          country: data.senderInfo?.address?.country,
        },
        recipientName: data.receiverInfo?.fullName,
        recipientEmail: data.receiverInfo?.contactEmail,
        recipientContact: {
          dialCode: data.receiverInfo?.contactNumber?.countryCode,
          number: data.receiverInfo?.contactNumber?.number,
        },
        recipientAddress: {
          street1: data.receiverInfo?.address?.street1,
          street2: data.receiverInfo?.address?.street2,
          postcode: data.receiverInfo?.address?.postcode,
          city: data.receiverInfo?.address?.city,
          state: data.receiverInfo?.address?.state,
          country: data.receiverInfo?.address?.country,
        },
        deliveryType: data?.deliveryType || null,
        serviceType: data?.serviceType || null,
        specialConditions: data?.specialCondition || null,
        height: data?.dimension?.height,
        width: data?.dimension?.width,
        length: data?.dimension?.length,
        parcels: data?.parcels,
        parcelType: data?.orderType,
      },
      isNil,
    );
  });
};

export default response;
